import {ContentHotel} from '@findhotel/sapi'

import {buildSeoApPath} from './getSeoAPPath'

import type {SeoBreadcrumbItem} from 'seo/getBreadcrumb'

type SeoBreadcrumbType = 'country' | 'city' | 'landmark' | 'hotel'

export interface ApSeoBreadcrumb {
  type: SeoBreadcrumbType
  name: string
  path: string
}

interface GetApSeoBreadcrumbParams {
  locale: string
  hotel: ContentHotel
  breadcrumb: SeoBreadcrumbItem[]
}

export const getApSeoBreadcrumb = ({
  locale,
  hotel,
  breadcrumb
}: GetApSeoBreadcrumbParams): ApSeoBreadcrumb[] => {
  if (!breadcrumb?.length || !hotel || !locale) {
    return []
  }

  const apSeoBreadcrumb: ApSeoBreadcrumb[] = breadcrumb.map(item => ({
    type: item.type,
    name: item.label,
    path: item.path
  }))

  apSeoBreadcrumb.push({
    type: 'hotel',
    name: hotel.hotelName,
    path: buildSeoApPath({
      hotelId: hotel.objectID,
      locale
    })
  })

  return apSeoBreadcrumb
}
